export default __webpack_public_path__ + "images/pages/quiz/categories/desktop_makeup-5b21c07c1840d49632678e1e9528d709.svg";